import React, { useEffect, useState } from "react";
import CourseCard from "./CourseCard";

const CourseBox = ({ title }) => {
	const [allCourses, setAllCourses] = useState(null);
	useEffect(() => {
		callApi();
	}, []);
	const callApi = async () => {
		const response = await fetch(
			`${process.env.REACT_APP_BACKEND_URL}/api/courses`
		)
			.then((response) => {
				if (!response.ok) {
					throw new Error("Network response was not ok");
				}
				return response.json();
			})
			.then((data) => {
				// console.log(data.courses);
				setAllCourses(data.courses);
			})
			.catch((err) => {
				console.log(err);
			});
	};
	if (allCourses == null) return null;
	return (
		<div>
			<h1 className="font-bold w-full text-center text-3xl mt-5">
				{title}
			</h1>
			<div className="flex flex-wrap gap-y-5 justify-around items-center m-10">
				{allCourses?.map((course, idx) => {
					return <CourseCard key={idx} course={course} />;
				})}
			</div>
		</div>
	);
};

export default CourseBox;
